/**
 * Lebanese pound.
 */
export var LBP = {
  code: 'LBP',
  base: 10,
  exponent: 2
};